module.exports = __webpack_public_path__ + "img/banner4.52ce8bd5.png";